export default "__VITE_ASSET__KpDo6AQx__"